/* tslint:disable */
/* eslint-disable */
export enum WorkAcDcEnum {
  Ac = 'AC',
  Dc = 'DC'
}
